'use client';
import { handleHeaderColorScheme } from '@lib/store/slices/ComponentsSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useScroll from '../hooks/useScroll';
import { useViewport } from '../hooks/useViewport';

const ScrollHelperBlackTrans = () => {
  const dispatch = useDispatch();

  const { scrollY } = useScroll();
  const { isMobile } = useViewport();

  useEffect(() => {
    dispatch(handleHeaderColorScheme('blackOnTransparentTwo'));
    return function () {
      dispatch(handleHeaderColorScheme(''));
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      dispatch(handleHeaderColorScheme(''));
    } else {
      if (scrollY < 50) {
        dispatch(handleHeaderColorScheme('blackOnTransparentTwo'));
      } else {
        dispatch(handleHeaderColorScheme(''));
      }
    }
  }, [scrollY, isMobile]);

  return null;
};

export default ScrollHelperBlackTrans;
